import PropTypes from 'prop-types';
import React, {useState, useEffect, useRef} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {FmlxIcon, FmlxTooltip} from 'fmlx-common-ui';

import {LabelBar} from '../../components';
import {useClickOutside} from '../../lib/customHooks';
import withIntl from '../../lib/withIntl';
import * as AppStateAction from '../../stores/actions/appStateAction';

import './DrawerButtonTitle.scss';
import {saveState} from '../../stores/business/stateBusiness';

const mapDispatchToProps = (dispatch) => ({
  appStateAction: bindActionCreators(AppStateAction, dispatch),
  saveStateAction: bindActionCreators(saveState, dispatch),
});

function DrawerButtonTitle(props) {
  const {
    title,
    drawerButtonVisible,
    editable,
    maxCharacters,
    showCharactersLeft,
    onChange,
    appStateAction,
    userName,
    intl,
    saveStateAction,
  } = props;

  const [titleState, setTitleState] = useState(title);
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    setTitleState(title);
  }, [title]);

  const inputRef = useRef(null);

  const setShowDrawer = async (data) => {
    await appStateAction.setDrawerVisibility(data);
    saveStateAction(false);
  };

  const onTitleClick = () => {
    setIsEditing(true);
  };

  const onTitleChange = (e) => {
    const newValue = e.target.value;

    if (newValue.length > maxCharacters) {
      return;
    }

    setTitleState(newValue);
  };

  const onTitleBlur = () => {
    setIsEditing(false);

    onChange(titleState);
  };

  const onTitleKeyDown = (e) => {
    if (e.keyCode !== 13) {
      return;
    }

    onTitleBlur();
  };

  useClickOutside(inputRef, () => {
    onTitleBlur();
  });

  return (
    <div className="menu-n-title">
      {drawerButtonVisible && (
        <div role="presentation" onClick={() => setShowDrawer(true)} className="header-menu-icon">
          <FmlxIcon name="BrowserMenu" customColor="white" size="md" />
        </div>
      )}
      {(!editable || (editable && !isEditing)) && (
        <LabelBar
          text={titleState}
          className={`title ${userName ? 'with-user' : ''}`}
          clickable={editable}
          onClick={onTitleClick}
        />
      )}
      {userName && (
        <FmlxTooltip title={intl.formatMessage({id: 'runtimeHeader.tooltip.user'}, {userName})}>
          <span style={{display: 'flex', marginRight: '10px'}}>
            <FmlxIcon name="Users" customColor="white" size="sm" />
          </span>
        </FmlxTooltip>
      )}
      {editable && isEditing && (
        <div className="input-container">
          <input
            // eslint-disable-next-line jsx-a11y/no-autofocus
            autoFocus
            ref={inputRef}
            type="text"
            value={titleState}
            onChange={onTitleChange}
            onBlur={onTitleBlur}
            onKeyDown={onTitleKeyDown}
          />
          {showCharactersLeft && <div className="chars-left">{`${titleState.length}/${maxCharacters}`}</div>}
        </div>
      )}
    </div>
  );
}

DrawerButtonTitle.propTypes = {
  intl: PropTypes.any.isRequired,
  appStateAction: PropTypes.object.isRequired,
  title: PropTypes.string,
  drawerButtonVisible: PropTypes.bool,
  editable: PropTypes.bool,
  maxCharacters: PropTypes.number,
  showCharactersLeft: PropTypes.bool,
  onChange: PropTypes.func,
  userName: PropTypes.string,
  saveStateAction: PropTypes.func.isRequired,
};

DrawerButtonTitle.defaultProps = {
  title: '',
  drawerButtonVisible: true,
  editable: false,
  maxCharacters: 25,
  showCharactersLeft: true,
  userName: '',
  onChange: () => {},
};

export default connect(null, mapDispatchToProps)(withIntl(DrawerButtonTitle));
